import React from 'react';

function ChevronLeft(props: object) {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.299951 6L6.29995 0L7.69995 1.4L3.09995 6L7.69995 10.6L6.29995 12L0.299951 6Z"
        fill="#1D1B20"
      />
    </svg>
  );
}

export default ChevronLeft;
